<template>
  <div class="full-container">
    <!-- <div class="full-container overview-introduce">
      <div
        class="container introduce-container-left"
        style="padding-top: 50px; padding-bottom: 50px"
      >
        <div class="title">爱浦京软件 · 数字化转型服务提供商</div>
        <div class="content">助力企业数字化转型，为客户创造竞争优势。</div>
        <div class="download-button">
          <a
            href="https://static.sxbang.net/apj/APJ%E5%AE%A3%E4%BC%A0%E5%86%8C%EF%BC%88%E9%AB%98%E6%B8%85%E7%89%88%E6%9C%AC%EF%BC%89.pdf"
            target="_blank"
          >
            下载电子宣传册
          </a>
        </div>
      </div>
    </div> -->

    <div class="container overview-info-container">
      <div class="overview-info">
        <div class="introduce-container-left">
          <div class="title pi-fw-900">公司简介</div>
          <div class="content">
            珠海爱浦京软件股份有限公司(简称APJ)由日本精工爱普生(EPSON)和北京中京工程设计软件技术有限公司(ZESTC)于2002年联合创办的一家具有跨国企业背景的高新技术企业。APJ致力于成为粤港澳大湾区领先的数字化转型服务提供商，为全球客户提供信息技术外包服务及数字化产品与解决方案。公司成功地在轨道交通、高端制造、银行金融、教育培训、终端零售、石油化工、环保等行业，为国内外上百家大型企业和政府客户提供专业服务。伴随着企业数字化转型的热潮，APJ持续加大研发投入，积极布局粤港澳大湾区，已经在数字工厂、互联网教育、医疗大健康等垂直产业形成一系列自主知识产权的数字化产品和解决方案，助力企业数字化转型，持续为客户创造竞争优势，是企业数字化转型的可信赖合作伙伴。
          </div>

          <div class="overview-button">
            <span class="overview-video" @click="showVideo">
              <i class="iconfont iconbofang play-icon"></i>
              <span>APJ品牌宣传视频</span>
            </span>
            <span class="overview-video">
              <a
                href="https://static.sxbang.net/apj/APJ%E5%AE%A3%E4%BC%A0%E5%86%8C%EF%BC%88%E9%AB%98%E6%B8%85%E7%89%88%E6%9C%AC%EF%BC%89.pdf"
                target="_blank"
              >
                <span>下载电子宣传册</span>
              </a>
            </span>
          </div>
        </div>
      </div>
      <!-- <div class="overview-red"></div> -->
    </div>

    <div
      class="container introduce-container-left overview-culture"
      style="margin-top: 50px"
    >
      <div class="title" style="padding-bottom: 10px">企业文化</div>
      <div class="cover">
        <el-image
          :src="require('@/assets/images/aboutus/culture.png')"
        ></el-image>
      </div>
      <div class="content">
        公司奉行“以人为本”、“奖励表现”的管理理念，关注员工与企业共同成长。建立了科学的人才选拔与发展体系、平等开放的职业晋升平台，注重知识传承、奖励工作贡献，不断稳定并扩大公司团队里的高素质、高忠诚度的人才精英。
      </div>
      <div class="content">
        文化是一种共识。APJ企业文化是APJ人的共识。它代表了APJ的团队气质和精神风貌，是APJ价值观在员工思想行为层面的延伸，更是APJ人在多年实践经验中总结并不断升华的企业精神与理念，
        同时也深深影响着每一位APJ人。我们坚信，在
        “创新、务实、人性化、分享、进取、育人”的企业文化指引下，APJ未来将会走更远，在更多的领域开创属于自己的辉煌，获得更大的成就。
      </div>
    </div>

    <div class="container" style="text-align: left">
      <div class="title">联系我们</div>
    </div>
    <div class="container contact-us">
      <div class="company-contact">
        <span class="map-title">珠海爱浦京软件股份有限公司</span>
        <span class="map-address"
          >广东省珠海市唐家湾大学路101号清华科技园4栋11层</span
        >
        <span>电话: (86) 756 339 2038/633 8688</span>
        <span>销售: (86) 756 633 8632</span>
        <span>邮箱: BD@apjcorp.com</span>
      </div>
      <div class="baidu-map" id="allmap"></div>
    </div>

    <!-- <div class="container culture-container">
      <div
        class="culture-item"
        :class="item.name ? '' : 'culture-empty'"
        v-for="(item, index) in cultureList"
        :key="'culture' + index"
        >
        <span class="culture-en-name">{{item.enName}}</span>
        <span class="culture-name">{{item.name}}</span>
      </div>
    </div> -->
    <apj-player ref="apjPlayer"></apj-player>
  </div>
</template>

<script>
import ApjPlayer from "@/components/apj-player";
import style from "./mapStyle";
export default {
  name: "product",
  components: {
    // videoPlayer,
    ApjPlayer
  },
  data() {
    return {
      video: require("@/assets/site/video_play.png"),
      cultureList: [
        {
          name: "责任",
          enName: "Responsible"
        },
        {
          name: "尊重",
          enName: "Respect"
        },
        {
          name: "创新",
          enName: "Innovative"
        },
        {
          name: "质量",
          enName: "Quality focus"
        },
        {
          name: "",
          enName: ""
        },
        {
          name: "",
          enName: ""
        },
        {
          name: "",
          enName: ""
        },
        {
          name: "关怀",
          enName: "Careing"
        },
        {
          name: "育人",
          enName: "People focus"
        },
        {
          name: "进取",
          enName: "Target drive"
        }
      ]
    };
  },
  mounted() {
    // var map = new BMapGL.Map("allmap"); // 创建Map实例
    // let point = new BMapGL.Point(113.590804, 22.350195);
    // map.centerAndZoom(point, 15); // 初始化地图,设置中心点坐标和地图级别
    // map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
    // // map.setHeading(64.5);
    // // map.setTilt(73);
    // map.setMapStyleV2({ styleJson: style.styleJson });
    // let marker = new BMapGL.Marker(point);
    // map.addOverlay(marker);
    // let opts = {
    //   width: 300,
    //   height: 60,
    //   title: "珠海爱浦京软件股份有限公司",
    // };
    // let infoWindow = new BMapGL.InfoWindow(
    //   "地址: 广东省珠海市唐家湾大学路101号清华科技园4栋11层",
    //   opts
    // );
    // map.openInfoWindow(infoWindow, point);

    //初始化地图对象
    var map = new T.Map("allmap");
    var zoom = 12;
    //设置显示地图的中心点和级别
    map.centerAndZoom(new T.LngLat(113.590804, 22.350195), zoom);
    var point = new T.LngLat(113.58, 22.350195);
    var marker = new T.Marker(point); // 创建标注
    map.addOverLay(marker);
    var markerInfoWin = new T.InfoWindow();
    var sContent = "<h3>珠海爱浦京软件股份有限公司</h3><div>地址: 广东省珠海市唐家湾大学路101号清华科技园4栋11层</div>"
    markerInfoWin.setContent(sContent);
    marker.openInfoWindow(markerInfoWin);
  },
  methods: {
    showVideo() {
      this.$refs["apjPlayer"].play();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/theme.scss";

div {
  width: 100%;
}

/** page style */
.overview-introduce {
  height: 500px;
  align-self: flex-start;
  background-image: url("~@/assets/site/aboutus_bg2.jpg");
  background-position: bottom;
}
.introduce-container {
  max-width: 1140px;
  padding: 80px;
}

.introduce-container-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.title {
  padding: 10px 0 30px;
  font-size: 30px;
  font-weight: bold;
}

.download-button {
  margin-top: 20px;
  width: 190px;
  height: 45px;
  text-align: center;
  line-height: 45px;
  border: 1px solid $color-border-primary;
}

.download-button:hover {
  cursor: pointer;
  background-color: $color-bg-primary;
  color: $color-text-white;
  a {
    color: $color-text-white;
  }
}

.overview-info-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;

  .overview-info {
    // width: calc(100% - 160px);
    margin-top: 50px;
    // filter: brightness(120%);
    // background-image: url("~@/assets/site/aboutus_bg.jpg");
    // background-image: url("~@/assets/images/aboutus/overview.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    .title {
      // color: $color-text-white;
    }
    .content {
      margin-bottom: 20px;
      // color: rgba(255, 255, 255, 0.8);
    }

    .overview-button {
      display: flex;
    }

    .overview-video {
      margin-top: 40px;
      margin-right: 40px;
      display: flex;
      align-items: center;
      transition: 0.5;
      // background-color: $color-bg-primary;
      border: 1px solid $color-border-primary;
      padding: 20px 40px;
      cursor: pointer;
      height: 50px;

      .play-icon {
        // width: 80px;
        // height: 40px;
        margin-right: 10px;
        font-size: 30px;
        color: $color-text-primary;
        text-indent: -5px;
      }

      span {
        // color: $color-text-white;
        font-weight: bold;
      }
    }
    .overview-video:hover {
      cursor: pointer;
      background-color: $color-bg-primary;
      span,
      i {
        color: $color-text-white;
      }
    }
  }

  .overview-red {
    width: 110px;
    height: 110px;
    margin-top: -110px;
    background-color: $color-bg-primary;
  }
}

.overview-culture {
  align-items: flex-start;
  // max-width: 1600px;
  .cover {
    // height: 280px;
    padding: 20px 0;
  }
  .content {
    margin-bottom: 20px;
  }
}

.culture-container {
  padding-bottom: 50px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  .culture-item {
    height: 146px;
    width: calc(20% - 10px);
    padding: 20px;
    margin: 5px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid $color-border-grey;
    .culture-en-name {
      font-size: 32px;
      white-space: nowrap;
      color: #eeeeee;
      font-weight: bold;
    }

    .culture-name {
      position: absolute;
      font-size: 24px;
      font-weight: bold;
      padding-bottom: 20px;
      border-bottom: 5px solid $color-border-primary;
    }
  }

  // .culture-item:hover {
  //   cursor: pointer;
  //   background-color: $color-bg-primary;

  //   .culture-en-name  {
  //     color: #fe2435;
  //   }

  //   .culture-name {
  //     color: $color-text-white;
  //     border-bottom: 5px solid $color-border-white;
  //   }
  // }

  .culture-empty {
    border: 0;
    background: unset;
  }
  .culture-empty:hover {
    cursor: unset;
    background: unset;
  }
}
.contact-us {
  display: flex;
  height: 360px;
  margin-bottom: 80px;

  .company-contact {
    width: 515px;
    padding: 80px 60px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: $color-bg-primary;
    span {
      color: $color-text-white;
    }
    .map-title {
      font-size: 26px;
      font-weight: bold;
    }
    .map-address {
      padding-bottom: 40px;
    }
  }
  .baidu-map {
    width: calc(100% - 515px);
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/aboutus/overview/index.vue